import { ClientHandleSettingsController } from './clientHandleSettings';
/** Standalone Settings uses existing form styles and updates fields without replacing their focus. */
export class ClientHandleSettingsPanel {
    constructor() {
        this.root = null;
        this.controller = new ClientHandleSettingsController(state => this.update(state));
        this.hasEdits = false;
    }
    setContainer(root) {
        const changed = this.root !== root;
        this.root = root;
        this.controller.setActive(Boolean(root?.isConnected));
        if (root && changed)
            this.create(root);
        this.update(this.controller.snapshot());
    }
    checkContext() {
        this.controller.setActive(Boolean(this.root?.isConnected));
        this.update(this.controller.snapshot());
    }
    create(root) {
        const doc = root.ownerDocument;
        const element = (tag, className, text = '') => {
            const node = doc.createElement(tag);
            node.className = className;
            node.textContent = text;
            return node;
        };
        const title = element('div', 'settings-group-title', 'Public handle');
        const message = element('div', 'settings-status');
        message.id = 'client-handle-status';
        message.setAttribute('role', 'status');
        message.setAttribute('aria-live', 'polite');
        const row = element('div', 'settings-row'), label = element('label', 'settings-label', 'Handle');
        label.htmlFor = 'settings-handle';
        const input = element('input', 'settings-input');
        input.id = 'settings-handle';
        input.type = 'text';
        input.placeholder = 'yourname';
        input.autocomplete = 'off';
        input.autocapitalize = 'none';
        input.spellcheck = false;
        input.setAttribute('aria-describedby', 'client-handle-status');
        row.append(label, input);
        const controls = element('div', 'settings-actions'), save = element('button', 'settings-btn', 'Save handle'), reload = element('button', 'settings-btn secondary', 'Reload saved handle');
        save.type = reload.type = 'button';
        save.id = 'client-handle-save';
        reload.id = 'client-handle-reload';
        controls.append(save, reload);
        root.replaceChildren(title, message, row, controls);
        const current = () => this.root === root && root.isConnected;
        input.addEventListener('input', () => { if (current())
            this.controller.actions().edit({ handle: input.value }); });
        // Capture the visit when controls are presented. A replaced account's DOM cannot submit its old draft.
        save.addEventListener('click', () => { if (current())
            this.saveAction?.(); });
        reload.addEventListener('click', () => { if (current())
            this.reloadAction?.(); });
        input.addEventListener('keydown', event => { if (current() && event.key === 'Enter') {
            event.preventDefault();
            this.saveAction?.();
        } });
        // A change saves when the field is left (Settings has no Save buttons, 2026-10-29).
        input.addEventListener('change', () => { if (current() && this.hasEdits)
            this.saveAction?.(); });
    }
    update(state) {
        const root = this.root;
        if (!root?.isConnected)
            return;
        const input = root.querySelector('#settings-handle');
        const save = root.querySelector('#client-handle-save'), reload = root.querySelector('#client-handle-reload'), message = root.querySelector('#client-handle-status');
        if (!input || !save || !reload || !message)
            return;
        const values = { handle: '', visibility: 'public', ...state.confirmed, ...state.edits };
        if (input.value !== values.handle)
            input.value = values.handle;
        save.disabled = Boolean(state.busy || state.needsReload || !state.confirmed);
        save.textContent = state.busy === 'save' ? 'Saving…' : 'Save handle';
        save.setAttribute('aria-busy', String(state.busy === 'save'));
        reload.disabled = Boolean(state.busy);
        reload.textContent = state.confirmed ? 'Reload saved handle' : 'Retry loading handle';
        // Enter or leaving the field saves; Reload shows only as the way out of a failure.
        save.hidden = true;
        reload.hidden = !(state.needsReload || (!state.busy && !state.confirmed) || state.tone === 'error');
        this.hasEdits = Boolean(state.confirmed) && (state.edits.handle ?? state.confirmed?.handle) !== state.confirmed?.handle;
        message.textContent = state.message;
        message.className = `settings-status ${state.tone}`;
        input.setAttribute('aria-invalid', String(state.tone === 'error' && state.message.startsWith('Use 3')));
        const actions = this.controller.actions();
        this.saveAction = actions.save;
        this.reloadAction = actions.reload;
    }
}
